<template>
  <v-dialog :value="show" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Delete</v-card-title>
        <v-card-text>You are about to delete a componet. Are you sure?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="gray" flat @click="inputHandler('disagree')">Disagree</v-btn>
          <v-btn color="red lighten-1" flat @click="inputHandler('agree')">Agree</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    inputHandler(choice) {
      this.$emit('action', choice)
    }
  },
}
</script>

<style></style>
